import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { ApiResponse } from '@/api/handlers/responses';
import { AttributeQueryKeys } from './attributeQueryKeys';

export type DeleteAttributeValueVariables = {
    typeId: string;
    valueId: string;
};

export const useDeleteAttributeValueMutation = () => {
    const { apiClient } = useApi();
    const queryClient = useQueryClient();

    return useMutation<ApiResponse<void>, Error, DeleteAttributeValueVariables>(
        {
            mutationFn: ({ typeId, valueId }) =>
                apiClient.attributeTypes.deleteValue(typeId, valueId),
            onSuccess: (result) => {
                if (result.success) {
                    queryClient.invalidateQueries({
                        queryKey: AttributeQueryKeys.all,
                    });
                }
            },
        },
    );
};
